<slate-children [children]="children" [context]="childrenContext" [viewContext]="viewContext"></slate-children>
<img src="assets/img/twemoji/72x72/{{ element.src }}.png" [alt]="element.alt" />
